module.exports = __webpack_public_path__ + "static/img/tabCardBg.9543c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/tabCardBg.png
// module id = DHjc
// module chunks = 0